import useMutationApi from 'src/api/useMutationApi';

export interface CreateUserRequest {
  name: string;
  email: string;
  password: string;
}

export interface CreateUserResponse {
  userId: string;
  name: string;
  email: string;
}

const useCreateUser = () => {
  return useMutationApi<CreateUserRequest, CreateUserResponse>({
    endpoint: 'organization/members',
    method: 'POST',
  });
};

export default useCreateUser;
